enum ViewTypes {
	list = 0,
	grid = 1,
}

export default ViewTypes